<template>
<div>
  <div class="dropdown">
    <button class="btn dropdown-toggle"
    				type="button"
    				id="dropdownMenuDepartArriveButton"
    				data-toggle="dropdown"
    				aria-haspopup="true"
    				aria-expanded="false">
      {{ valueFormatted }}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuDepartArriveButton">
      <a v-for="(option, index) in options"
         :key="index"
         @click="changeHandler(option)"
         class="dropdown-item">
        {{ option.label }}</a>      
    </div>
  </div>
  <!-- <div class="dropdown">
    <select class="form-control"
            name="select-depart-arrive"
            tabindex="0" 
            title="Select leave now, depart at or arrive by" 
            aria-label="Select leave now, depart at or arrive by"
            v-model="value">
      <option v-for="(option, index) in options" 
      				:value="option.value"
      				:key="index">
        {{ option.label }}</option>  
    </select>      
  </div> -->  
</div>
</template>
<script>

export default {
  name: 'depart-arrive-options',
  props: ['format'],
  data () {
    return {
    	value2: 'now',
    	options: [
    		{ value: 'now', label: 'Leave Now' },
    		{ value: 'depart', label: 'Leave At' },
    		{ value: 'arrive', label: 'Arrive By' }
    	]
    }
  },
  computed: {  	
    value: {
      get: function() {
        return this.$store.getters['tripPlanner/inputs'].when.type;
      },
      set: function( val ) {
        this.$store.commit('tripPlanner/SET_INPUT_DEPART_ARRIVE', val);
      }
    },   	
  	valueFormatted () {
  		let v = this.options.find(x => x.value === this.value)
  		if (!v) {
  			return 'NOT FOUND!'
  		}
  		return v.label
  	}, 	
  },
  methods: {
  	changeHandler (option) {
      this.value = option.value
  	}
  },
  mounted () {
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/DepartArriveOptions.vue